import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
import { CredentialsBar } from './CredentialsBar';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-black" data-id="element-707">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-708">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-709">
          <div className="md:col-span-2" data-id="element-710">
            <Link to="/" className="inline-block mb-4" data-id="element-711">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-712" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-713">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-714">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-715">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-716">
              <li data-id="element-717">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-718">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-719">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-720">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-721">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-722">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-723">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-724">
              <li className="flex justify-between" data-id="element-725">
                <span data-id="element-726">{t('footer.monFri')}</span>
                <span data-id="element-727">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-728">
                <span data-id="element-729">{t('footer.saturday')}</span>
                <span data-id="element-730">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-731">
                <span data-id="element-732">{t('footer.sunday')}</span>
                <span data-id="element-733">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-734">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-735">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-736">
              <li data-id="element-737">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-738">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-739">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-740">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-741">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-742">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-743">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-744">
                  {t('footer.diyGuide')}
                </Link>
              </li>
              <li data-id="element-745">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-746">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-747">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-748">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-749">
          <p data-id="element-750">
            &copy; {new Date().getFullYear()} 253Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-751">
            <a href="#" className="hover:text-white transition-colors" data-id="element-752">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-753">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
      <CredentialsBar data-id="element-754" />
    </footer>;
}